import { render, staticRenderFns } from "./2faTOTP.vue?vue&type=template&id=30a2a65a&scoped=true&"
import script from "./2faTOTP.vue?vue&type=script&lang=js&"
export * from "./2faTOTP.vue?vue&type=script&lang=js&"
import style0 from "./2faTOTP.vue?vue&type=style&index=0&id=30a2a65a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a2a65a",
  null
  
)

export default component.exports